import { useUser } from "../providers/UserProvider";
import { User } from "../storage/store";

// The signed-in user's role in the selected property ("owner" or "guest"), from
// the property list; undefined until the list has loaded.
export const usePropertyRole = () => {
  const { profileName } = useUser();
  return profileName.find((house) => house.id === User.getPropertyId())?.role;
};

// Whether the signed-in user created the selected property (its config's
// ownedBy): the only user the API lets share it or change and remove its
// members. Owners it was shared with can't. Until a page has loaded the
// config, is_superOwner on the user's own share stands in, as in the app
// (app/hooks/usePropertyOwner.js).
const usePropertyOwner = () => {
  const { profileName, propertyOwner } = useUser();
  const propertyId = User.getPropertyId();
  const username = User.getUser();
  if (propertyOwner?.propertyId === propertyId && propertyOwner.ownedBy && username) {
    return propertyOwner.ownedBy === username;
  }
  return profileName.find((house) => house.id === propertyId)?.superOwner === true;
};

export default usePropertyOwner;
